import React from 'react'
import { DataTable } from '../../CommonComponent'
import { IContainerProps } from './archiveinterface'
import './archive.scss'
import Loader from '../../Loader'
import ExportexcelComp from '../../CommonComponent/ExportExcel';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";

const Archive = (props: IContainerProps) => {
    const { t } = useTranslation();

    const archivecolumns = props?.archivecolumns?.length ? props?.archivecolumns : []
    const selectedArchieveObject = props?.selectedArchieveObject ?? {};
    const ExportArchiveColumn = [
        {
            title: t(RESOURCE.MyK_Label_ShoppingCart_Quote_Number),
            field: 'quoteNumber',
            width: 150,
        },
        {
            title: t(RESOURCE.MyK_Label_ShoppingCart_Quote_Name),
            field: 'quoteName',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Label_SC_NoOfParts),
            field: 'totParts',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Label_Comments),
            field: 'comments',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Label_ShoppingCart_Shared_With),
            field: 'sharedToUserEmail',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Label_ShoppingCart_Created_By),
            field: 'sharedByUserEmail',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Label_ShoppingCart_Created_Date),
            field: 'createdUTCDateExcel',
            width: 150
        }
    ]

    const ExportArchiveDetailColumn = [
        {
            title:  t(RESOURCE.MyK_Grid_Manufacturer),
            field: 'manufacturerName',
            width: 150,
        },
        {
            title: t(RESOURCE.MyK_Grid_Parts_Number),
            field: 'partNumber',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Grid_Description),
            field: 'description',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Grid_Qty),
            field: 'partQty',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Grid_Machine),
            field: 'machine',
            width: 150
        }
    ]

    return (
        <div className='archivegrid'>
            {props?.isLoading && <Loader />}
            {props.showsharedDetails ? null : <div><DataTable
                data={props?.data}
                dataColumn={archivecolumns}
                dataItemKey='id' exportRef={props?.gridRef} setMount={props?.setMount}
                storageKey={"archive"} enableFiltering={true}
            />
                {props?.mount?.flag && <ExportexcelComp
                    data={props?.mount?.data?.length ? props?.mount?.data : props?.data ?? []}
                    setMount={props?.setMount}
                    exportColumn={ExportArchiveColumn}
                    ExportFileName='QuoteList_'
                />}
            </div>}
            {props.showsharedDetails ? <div className='sharedDetailWrapper'>
                <div className='sharedDetailWrapperHD my-3'>
                    <span className='mr-3'><strong>{t(RESOURCE.MyK_Label_SC_Quote)} #:</strong> {selectedArchieveObject?.quoteNumber}</span>
                    {(selectedArchieveObject?.quoteName ?? "") != "" && <span className='mr-3'><strong>{t(RESOURCE.MyK_Label_ShoppingCart_Title)} :
                    </strong> {selectedArchieveObject?.quoteName}</span>}
                    {(selectedArchieveObject?.fileDisplayName ?? "") != "" && <span className='mr-3'><strong>{t(RESOURCE.MyK_AppNotificationLabel_Attachment)} :</strong> <span className="attachmentLink" onKeyDown={() => { }} onClick={() => props.downloadAttachment(selectedArchieveObject)}> {selectedArchieveObject?.fileDisplayName}</span> </span>}
                </div>
                {props?.isDetailsLoading && <Loader />}
                <div><DataTable
                storageKey={"archiveDetail"} enableFiltering={true}
                    data={selectedArchieveObject?.quoteList ?? []}
                    dataColumn={props.archieveDetailscolumns}
                    dataItemKey='id'
                    exportRef={props?.gridRef} setMount={props?.setMount}
                />
                    {props?.mount?.flag && <ExportexcelComp
                        data={props?.mount?.data?.length ? props?.mount?.data : selectedArchieveObject?.quoteList ?? []}
                        setMount={props?.setMount}
                        exportColumn={ExportArchiveDetailColumn}
                        ExportFileName='QuoteDetailList_'
                    />}
                </div>
                {
                    ((selectedArchieveObject?.comments??"")!="") &&
                    <div className='sharedDetailWrapperHD my-3'>
                        <span className='my-2'><strong>{t(RESOURCE.MyK_Label_Comments)} :</strong></span>
                            <textarea rows={1} readOnly={true} className='sharedTextarea' onChange={(e) => { props?.onCommentChange(e?.target?.value ?? '') }} value={selectedArchieveObject?.comments}></textarea>
                    </div>
                }
            </div> : null}
        </div>
    )
}

export default Archive